<template>
    <div v-if="show" class="get-app-overlay" @click.self="closeSheet">
        <div class="get-app-sheet">
            <button class="close-btn" @click="closeSheet" aria-label="Close">
                <Icon icon="mdi:close" width="20" height="20" />
            </button>

            <img src="@/assets/images/Ft.webp" alt="App Preview" class="phone-mockup" @error="handleImageError" />

            <div class="content-section">
                <h2>QwikU</h2>
                <h2>Digital Business Card</h2>
                <p class="subtitle">
                    Show, Don't Just Tell.
                </p>

                <button class="get-app-btn" @click="handleGetApp">
                    Get the app
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue';
import '@/assets/styles/GetAppBottomSheet.css';

// Using a placeholder image if the specific asset isn't available
// You might want to replace this with the actual image path
const defaultImage = 'https://placehold.co/200x400/png?text=App+Preview';

defineProps<{
    show: boolean;
}>();

const emit = defineEmits<{
    (e: 'close'): void;
}>();

const closeSheet = () => {
    emit('close');
};

const handleGetApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/android/i.test(userAgent)) {
        // Android - Open Play Store
        window.open('https://play.google.com/store/apps/details?id=com.ScanbCard.smartcard_app', '_blank');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
        // iOS - Open App Store
        window.open('https://apps.apple.com/us/app/smartcard-qr-business-card/id1541370437', '_blank');
    } else {
        // Web or other
        window.open('https://qwiku.com', '_blank');
    }
    closeSheet();
};

const handleImageError = (e: Event) => {
    (e.target as HTMLImageElement).src = defaultImage;
};
</script>
